import { useEffect } from "react";
import { useStateful } from "~/src/hooks/useStateful";

export type ErrorListProps<T> = {
  errors: Partial<Record<keyof T, string>>;
};

export default function ErrorList<T>(props: ErrorListProps<T>): JSX.Element {
  const { errors } = props;
  const errorListItems = useStateful<string[]>([]);

  useEffect(() => {
    const newList: string[] = [];
    for (const error in errors) {
      let e = errors[error];
      if (e?.endsWith(".")) {
        e = e.slice(0, -1);
      }
      if (e && !newList.includes(e)) newList.push(e);
    }
    errorListItems.set(newList);
  }, [errors]);

  return (
    <ul className="list-disc pl-5">
      {errorListItems.value.map((e) => (
        <li key={e}>{e}</li>
      ))}
    </ul>
  );
}
